import React, {useState} from 'react'
import {Modal, Input, Row, Col, notification, Button, Select } from 'antd'

const { Option } = Select;

function ProductModalNew(props){
    const[nombre, setNombre] = useState("");
    const[description, setDescription] = useState("");
    const[prodId, setProdId] = useState("");
    const[unitId, setUnitId] = useState("S");
    const[categoryName, setCategoryName] = useState("");
    const[prodCategory, setProdCategory] = useState("S");
    const[prod, setProd] = useState("");
    const[labelVisible, setLabelVisible] = useState(false);
    const[labelFormatVisible, setLabelFormatVisible] = useState(false);

    const msNotification = (type, title, desc) => {
        notification[type]({
            message: title,
            description:
            desc,
        });
    };

    const handleOk = () => {
        if(prodId !== ""){
            if(!labelVisible){
                if(!labelFormatVisible){
                    if(nombre !== ""){
                        if(description !== ""){
                            if(prodCategory !== "S"){
                                if(unitId !== "S"){
                                        const newProduct = {
                                            prodName: nombre,
                                            prodDesc: description,
                                            prodId: prodId,
                                            prodUnit: unitId,
                                            prodCategory: prodCategory,
                                            prodCategoryName: categoryName
                                        }
                                        props.handleOkModalNew(newProduct);
                                        setNombre("");
                                        setDescription("");
                                        setCategoryName("");
                                        setProdId("");
                                        setUnitId("S");
                                        setProdCategory("S");
                                }else{
                                    msNotification('warning', 'Producto', 'Selecciona una unidad de medida para el producto.');
                                }
            
                            }else{
                                msNotification('warning', 'Producto', 'Selecciona una categoría para el producto.');
                            }
                        }else{
                            msNotification('warning', 'Producto', 'La descripción del producto no debe de ser vacio.');
                        }
                    }else{
                        msNotification('warning', 'Producto', 'El nombre del producto no debe de ser vacio.');
                    }
                }
            }
        }else{
            msNotification('warning', 'Producto', 'El Id del producto no debe de ser vacio.');
        }
        
      };

    const handleCancel = () => {
        setCategoryName("");
        setNombre("");
        setDescription("");
        setProdCategory("S");
        setProdId("");
        setUnitId("S");
        setProd("");
        setLabelVisible(false);
        setLabelFormatVisible(false);
        props.handleCancelModalNew();
    }

    const handleNameChange = (e) => {
        setNombre(e.target.value);
    }

    const handleIdChange = (e) => {
        let regex = new RegExp("^[a-zA-Z0-9]+$");
        setProdId(e.target.value);
        if (regex.test(e.target.value)) {
            setLabelFormatVisible(false);
        } else {
            setLabelFormatVisible(true);
        }
    }

    const handleDescriptionChange = (e) => {
        setDescription(e.target.value);
    }

    function handleChangeCategory(value, e) {
        setCategoryName(e.children);
        setProdCategory(value);
    }

    function handleChangeUnit(value) {
        setUnitId(value);
    }

    const handleOnKeyUp = (e) => {
        let item = props.dataProducts.find(element => element.id.toUpperCase() === e.target.value.toUpperCase());
        if(item !== undefined){
            setProd(item.name);
            setLabelVisible(true);
        }else{
            setProd('');
            setLabelVisible(false);
        }
    }


    return(
        <React.Fragment>
            <Modal title="Nuevo Producto" 
            visible={props.modalVisibleNew}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
                <Button key="back" onClick={handleCancel}>
                  Cancelar
                </Button>,
                <Button key="submit" type="primary" onClick={handleOk}>
                  Guardar
                </Button>
              ]}>
                <Row>
                    <Col span={24}>
                        <Input value={prodId} onChange={handleIdChange} onKeyUp={handleOnKeyUp} placeholder="Id" maxLength="15" />
                        {labelFormatVisible ? <p style={{color:"red"}}>*El ID solo debe de contener letras y números</p>: null}
                        {labelVisible ? <p style={{color:"red"}}>*El ID ya esta asignado al producto: {prod}</p>: null}
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                    <Col span={24}>
                        <Input value={nombre} onChange={handleNameChange} placeholder="Nombre" />
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                    <Col span={24}>
                        <Input value={description} onChange={handleDescriptionChange} placeholder="Descripción" />
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                    <Col span={24}>
                        <Select value={prodCategory} style={{ width: '100%' }} className="cbx-widht" onChange={handleChangeCategory}>
                            <Option value="S">Selecciona una Categoría</Option>
                            {props.dataCategories.map(function(obj){
                                return <Option key={obj.id} value={obj.id}>{obj.name}</Option>
                            })}
                        </Select>
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                    <Col span={24}>
                        <Select value={unitId} style={{ width: '100%' }} onChange={handleChangeUnit}>
                            <Option value="S">Selecciona una unidad de medida</Option>
                            {props.dataUnits.map(function(obj){
                                return <Option key={obj.unit} value={obj.unit}>{obj.description}</Option>
                            })}
                        </Select>
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                </Row>
            </Modal>

        </React.Fragment>
    )
}

export default ProductModalNew;



// WEBPACK FOOTER //
// ./src/components/ProductModalNew.jsx